import LoopWinsMediator from "ags/mediators/loop-wins-mediator";
import Mediators from "ags/mediators/mediators";
import State from "slotworks/state-machine/states/state";

export default class AGSLoopWins extends State {

    protected loopWinsMediator: LoopWinsMediator;

    public onEnter() {
        this.loopWinsMediator = new Mediators.LoopWinsMediatorType();
        this.loopWinsMediator.start().then(() => this.complete());
    }

    public onExit() {
        this.loopWinsMediator.end().execute();
    }
}
